import { ISimulationLastStep } from 'store/modules/simulation/types'
import { ISimulation } from 'egi/types'

/**
 * Converte um objeto ISimulation
 * no formato esperado por ISimulationLastStep.
 *
 * @param values Objeto ISimulation
 * @returns Objeto ISimulationLastStep
*/
export function convertToSimulationLastStep (values: ISimulation): ISimulationLastStep {
  return {
    amortizationType: values?.amortizationType || '',
    creditValue: values?.creditValue,
    deadline: values?.deadline,
    financing: values?.financing,
    index: values?.index,
    liquid: values?.liquid,
    parcels: values?.parcels || [],
    taxes: values?.taxes || {},
    possibleIndexes: [values?.index].filter(Boolean),
    productId: values?.productId,
    propertyValue: values?.propertyValue,
    simulationId: values?._id || '',
    sub: values?.sub || '',
    registerValue: values?.registerValue || 0
  }
}
